import { Autocomplete, Box, Button, TextField } from '@mui/material';
import React, { useState } from 'react';
import styled from 'styled-components';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import CustomHeader from '../../../components/common/header/CustomHeader';
import Sidebar from '../../../components/common/sidebar/Sidebar';
import OpaqueLoading from '../../../components/opaqueLoading/opaqueLoading';

const isMobile = window.innerWidth < 900;

const StaffEditorPageContainer = styled.div`
  width: 100%;
  ${isMobile && `position: relative;`}
`;

const Container = styled.div`
  width: 100%;
`;

const NotDiv = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 600;
`;

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const targetVisibilities = ['Employee Wise', 'Territory Wise'];

const AssignedTargetAchievement = () => {
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState();
  const [selectedMonth, setSelectedMonth] = useState();
  const [selectedTargetVisibility, setSelectedTargetVisibility] = useState();
  const [selectedEvent, setSelectedEvent] = useState();
  const [events, setEvents] = useState([]);
  const [payload, setPayload] = React.useState({});

  const [tableHeaders, setTableHeaders] = React.useState();
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    const user = JSON.parse(localStorage.getItem('storedUserData'));
    if (user) {
      const years = [];
      const date = new Date();
      const currentYear = date.getFullYear();
      const currentMonth = months[date.getMonth()];
      const nextYear = currentYear + 1;
      years.push(currentYear);
      years.push(nextYear);
      setYears(years);
      setSelectedYear(currentYear);
      setSelectedMonth(currentMonth);
      setSelectedTargetVisibility('Employee Wise');
      getActivityType(currentMonth, currentYear, 'Employee Wise');
    } else {
      window.location.reload();
    }
  }, []);

  const getActivityType = async (
    currentMonth,
    currentYear,
    targetVisibility
  ) => {
    try {
      setLoading(true);
      const result = await window.Platform.database.getActivityType();
      setEvents(result.data);
      setSelectedEvent(result.data[0]);
      setPayload({
        Year__c: currentYear,
        Month__c: currentMonth,
        Visibility: 'Employee Wise',
        eventType: result.data[0],
      });
      await getTargetActivity(
        currentMonth,
        currentYear,
        targetVisibility,
        result.data[0].value
      );
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleYearChange = async (value) => {
    setSelectedYear(value ?? null);
    setSelectedMonth(null);
    setSelectedTargetVisibility(null);
    setSelectedEvent(null);
  };

  const handleMonthChange = async (value) => {
    setSelectedMonth(value ?? null);
    setSelectedEvent(null);
    setSelectedTargetVisibility(null);
  };

  const handleTargetVisibilityChange = async (value) => {
    setSelectedTargetVisibility(value ?? null);
    setSelectedEvent(null);
  };

  const handleEventChange = async (value) => {
    setSelectedEvent(value ?? null);
  };

  const handleFilterSubmit = async () => {
    try {
      if (
        !selectedYear ||
        !selectedMonth ||
        !selectedTargetVisibility ||
        !selectedEvent?.value
      ) {
        window.NotificationUtils.showError(
          'Year, month, target visibility and event type must be selected to get filtered targets.'
        );
        return;
      }

      setLoading(true);
      await getTargetActivity(
        selectedMonth,
        selectedYear,
        selectedTargetVisibility,
        selectedEvent?.value
      );
    } catch (error) {
      window.NotificationUtils.showError(error?.message);
      setLoading(false);
    }
  };

  const getTargetActivity = async (
    month = null,
    year = null,
    targetVisibility = null,
    eventType = null
  ) => {
    try {
      if (!month || !year || !targetVisibility || !eventType) {
        setTableHeaders([]);
        return;
      }

      setPayload((p) => {
        return {
          ...p,
          Year__c: year ? year : selectedYear,
          Month__c: month ? month : selectedMonth,
          Visibility: targetVisibility
            ? targetVisibility
            : selectedTargetVisibility,
          eventType: eventType
            ? typeof eventType === 'object'
              ? eventType?.value
              : eventType
            : typeof selectedEvent === 'object'
            ? selectedEvent?.value
            : selectedEvent,
        };
      });

      setLoading(true);
      setTableHeaders([]);
      const result = await window.Platform.database.getTargetActivity({
        Year__c: year ? year : selectedYear,
        Month__c: month ? month : selectedMonth,
        Visibility: targetVisibility
          ? targetVisibility
          : selectedTargetVisibility,
        eventType: eventType
          ? typeof eventType === 'object'
            ? eventType?.value
            : eventType
          : typeof selectedEvent === 'object'
          ? selectedEvent?.value
          : selectedEvent,
      });

      const filteredEmployeeData = result.data.employeeData.filter((item) => {
        return item.data?.length > 0;
      });

      const finalResult = filteredEmployeeData.map((item) => {
        return {
          ...item,
        };
      });

      const updatedData = {
        ...result.data,
        employeeData: finalResult,
      };

      setTableHeaders(updatedData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      window.NotificationUtils.showError(error?.message);
    }
  };

  const renderContent = () => {
    return (
      <Box
        style={{
          height: !tableHeaders?.employeeData?.length ? '380px' : '550px',
          overflow: 'auto',
        }}
      >
        {tableHeaders?.employeeData?.length > 0 ? (
          <TableContainer
            component={Paper}
            sx={{
              borderRadius: '10px',
              overflowX: 'auto',
              maxWidth: '100%',
              maxHeight: 500,
            }}
          >
            <Table sx={{ minWidth: 700 }} aria-label='spanning table'>
              <TableHead sx={{ position: 'sticky', top: 0, zIndex: 3 }}>
                <TableRow sx={{ backgroundColor: '#77A600' }}>
                  <TableCell
                    rowSpan={3}
                    sx={{
                      position: 'sticky',
                      left: 0,
                      zIndex: 4,
                      backgroundColor: '#77A600',
                      color: '#FFF',
                      border: '1px solid #E6E6E6',
                    }}
                  >
                    {payload.Visibility === 'Employee Wise'
                      ? 'Employee Name'
                      : 'Territory Wise'}
                  </TableCell>

                  {tableHeaders?.headerData?.map((item, index) => (
                    <TableCell
                      key={`main-header-${index}`}
                      align='center'
                      sx={{ border: '2px solid #E6E6E6', color: '#FFF' }}
                      colSpan={item?.Value?.length * 2 || 0}
                    >
                      {item?.key}
                    </TableCell>
                  ))}
                </TableRow>

                {!tableHeaders?.headerData?.some((item) =>
                  [
                    'Van Campaign',
                    'Retailer Meet',
                    'Balloon Show',
                    'Krishi Mela',
                  ].includes(item.key)
                ) && (
                  <TableRow sx={{ backgroundColor: '#77A600' }}>
                    {tableHeaders?.headerData?.flatMap(
                      (headerItem, headerIndex) =>
                        headerItem?.Value?.map((productItem, productIndex) => (
                          <TableCell
                            key={`product-${headerIndex}-${productIndex}`}
                            align='center'
                            sx={{ border: '2px solid #E6E6E6', color: '#FFF' }}
                            colSpan={2}
                          >
                            {productItem?.key}
                          </TableCell>
                        ))
                    )}
                  </TableRow>
                )}

                <TableRow sx={{ backgroundColor: '#77A600' }}>
                  {tableHeaders?.headerData?.flatMap(
                    (headerItem, headerIndex) =>
                      headerItem?.Value?.flatMap((productItem, productIndex) =>
                        productItem?.value?.map((metric, metricIndex) => (
                          <TableCell
                            key={`metric-${headerIndex}-${productIndex}-${metricIndex}`}
                            align='center'
                            sx={{ border: '2px solid #E6E6E6', color: '#FFF' }}
                          >
                            {metric}
                          </TableCell>
                        ))
                      )
                  )}
                </TableRow>
              </TableHead>

              <TableBody>
                {tableHeaders?.employeeData?.map((row, newIndex) => (
                  <TableRow
                    key={row.name__c}
                    hover
                    role='checkbox'
                    tabIndex={-1}
                    sx={{
                      backgroundColor:
                        newIndex % 2 !== 0 ? 'rgb(246, 255, 222)' : 'inherit',
                      '&:last-child td, &:last-child th': { border: 0 },
                    }}
                  >
                    <TableCell
                      sx={{
                        position: 'sticky',
                        left: 0,
                        backgroundColor:
                          newIndex % 2 !== 0 ? 'rgb(246, 255, 222)' : '#FFF',
                        zIndex: 2,
                      }}
                    >
                      {row.name__c}
                    </TableCell>

                    {tableHeaders?.headerData?.flatMap((headerItem) =>
                      headerItem?.Value?.flatMap((productItem) => {
                        const productData = row.data.find(
                          (d) => d.key === productItem.key
                        );

                        return productItem?.value?.map((metric) => {
                          const metricObj = productData?.Value?.find(
                            (v) => v.key === metric
                          );
                          return (
                            <TableCell
                              key={`${row.name__c}-${productItem.key}-${metric}`}
                              align='center'
                            >
                              {metricObj?.value ?? 0}
                            </TableCell>
                          );
                        });
                      })
                    )}
                  </TableRow>
                ))}

                <TableRow
                  sx={{
                    backgroundColor: '#77A600',
                    position: 'sticky',
                    bottom: 0,
                    zIndex: 3,
                  }}
                >
                  <TableCell
                    align='center'
                    sx={{
                      position: 'sticky',
                      left: 0,
                      backgroundColor: '#77A600',
                      color: '#FFF',
                      zIndex: 3,
                    }}
                  >
                    Total
                  </TableCell>

                  {tableHeaders?.headerData?.flatMap((headerItem) =>
                    headerItem?.Value?.flatMap((productItem) =>
                      productItem?.value?.map((metric) => {
                        const total = tableHeaders.employeeData.reduce(
                          (sum, emp) => {
                            const productData = emp.data.find(
                              (d) => d.key === productItem.key
                            );
                            const metricObj = productData?.Value?.find(
                              (v) => v.key === metric
                            );
                            return sum + Number(metricObj?.value || 0);
                          },
                          0
                        );

                        return (
                          <TableCell
                            key={`total-${productItem.key}-${metric}`}
                            align='center'
                            sx={{
                              position: 'sticky',
                              bottom: 0,
                              backgroundColor: '#FFF',
                              zIndex: 2,
                            }}
                          >
                            {total}
                          </TableCell>
                        );
                      })
                    )
                  )}
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <NotDiv>No Data Found</NotDiv>
        )}
      </Box>
    );
  };

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        backgroundColor: '#F6F6F6',
        minHeight: '100vh',
      }}
    >
      <Sidebar />
      <Container>
        {loading && <OpaqueLoading />}
        <CustomHeader name='assigned-target-achievement' />
        <Box p={4}>
          <Box
            display='flex'
            flexDirection='row'
            alignItems='center'
            justifyContent='flex-end'
            flexWrap='wrap'
            gap='10px'
          >
            <Box
              display='flex'
              alignItems='center'
              justifyContent='flex-end'
              flexWrap='wrap'
              gap='10px'
              mb={2}
            >
              <Autocomplete
                size='small'
                sx={{ width: '200px' }}
                value={selectedYear || null}
                onChange={(event, newValue) => handleYearChange(newValue)}
                options={years}
                getOptionLabel={(option) => option}
                isOptionEqualToValue={(option, value) => option === value}
                autoComplete='off'
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='Select Year'
                    slotProps={{
                      input: {
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      },
                    }}
                  />
                )}
                filterOptions={(options, { inputValue }) => {
                  return options.filter((option) =>
                    String(option)
                      .toLowerCase()
                      .includes(inputValue.toLowerCase())
                  );
                }}
              />

              <Autocomplete
                size='small'
                sx={{ width: '200px' }}
                value={selectedMonth || null}
                onChange={(event, newValue) => handleMonthChange(newValue)}
                options={months}
                getOptionLabel={(option) => option}
                isOptionEqualToValue={(option, value) => option === value}
                autoComplete='off'
                // getOptionDisabled={(option) => {
                //   const currentDate = new Date();
                //   const currentMonthIndex = currentDate.getMonth();
                //   const currentYear = currentDate.getFullYear();

                //   if (parseInt(selectedYear) === currentYear) {
                //     const monthIndex = months.findIndex(
                //       (month) => month.toLowerCase() === option.toLowerCase()
                //     );
                //     return monthIndex < currentMonthIndex;
                //   }
                //   return false;
                // }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='Select Month'
                    slotProps={{
                      input: {
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      },
                    }}
                  />
                )}
                filterOptions={(options, { inputValue }) => {
                  return options.filter((option) =>
                    option.toLowerCase().includes(inputValue.toLowerCase())
                  );
                }}
              />

              <Autocomplete
                size='small'
                sx={{ width: '200px' }}
                value={selectedTargetVisibility || null}
                onChange={(event, newValue) =>
                  handleTargetVisibilityChange(newValue)
                }
                options={targetVisibilities}
                getOptionLabel={(option) =>
                  typeof option === 'string' ? option : option || ''
                }
                isOptionEqualToValue={(option, value) => option === value}
                fullWidth
                autoComplete='off'
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='Target Visibility'
                    slotProps={{
                      input: {
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      },
                    }}
                  />
                )}
                filterOptions={(options, { inputValue }) => {
                  return options.filter((option) =>
                    option.toLowerCase().includes(inputValue.toLowerCase())
                  );
                }}
              />

              <Autocomplete
                size='small'
                sx={{ width: '200px' }}
                value={selectedEvent || null}
                onChange={(event, newValue) => handleEventChange(newValue)}
                options={events}
                getOptionLabel={(option) =>
                  typeof option === 'string' ? option : option?.eventName || ''
                }
                isOptionEqualToValue={(option, value) =>
                  option.eventName === value
                }
                fullWidth
                autoComplete='off'
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='Event Type'
                    slotProps={{
                      input: {
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      },
                    }}
                  />
                )}
                filterOptions={(options, { inputValue }) => {
                  return options.filter((option) =>
                    option.eventName
                      .toLowerCase()
                      .includes(inputValue.toLowerCase())
                  );
                }}
              />
            </Box>
            <Box display='flex' alignItems='center' gap='10px' mb={2}>
              <Button
                variant='contained'
                onClick={handleFilterSubmit}
                style={{
                  background:
                    'linear-gradient(90deg, #77A600 0%, #A8CF45 100%)',
                }}
              >
                Fetch
              </Button>
            </Box>
          </Box>
          <StaffEditorPageContainer>
            <TableContainer>{renderContent()}</TableContainer>
          </StaffEditorPageContainer>
        </Box>
      </Container>
    </div>
  );
};

export default AssignedTargetAchievement;
